import {
  OBJECT_BASE_SIZE,
  OBJECT_MAX_SIZE,
} from "components/features/ProgressReportViewer/utils";

export const getCircleSize = (zoomLevel: number) =>
  zoomLevel < 1
    ? Math.min(OBJECT_BASE_SIZE / zoomLevel, OBJECT_MAX_SIZE)
    : OBJECT_BASE_SIZE;
